import React from 'react'
import { Modal, ModalBody, Carousel, Button, spacing } from '@retailer-platform/shared-components'
import styled from '@emotion/styled'
import FeatureEducationSlideLayout from './FeatureEducationSlideLayout'
import FeatureHighlightIntroduction from './FeatureHighlightIntroduction'
import FeatureHighlightIntroductionImage from 'assets/featureHighlights/feature-education-banner.png'
import { type FeatureHighlight } from './types'

interface FeatureEducationModalProps {
  isOpen: boolean
  onClose: (id?: string) => void
  features: FeatureHighlight[]
  onNextFeature: (currentFeatureId: string) => void
}

const StyledModalHeader = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  paddingTop: spacing.X16,
  paddingRight: spacing.X16,
})

const StyledModalBody = styled(ModalBody)({
  paddingTop: 0,
})

const INTRO_SLIDE_ID = 'intro'

const FeatureEducationModal = ({
  isOpen,
  onClose,
  onNextFeature,
  features = [],
}: FeatureEducationModalProps) => {
  const firstSlide = [
    {
      id: INTRO_SLIDE_ID,
      img: FeatureHighlightIntroductionImage,
      name: 'Intro',
      // eslint-disable-next-line react/no-multi-comp
      Component: () => (
        <FeatureHighlightIntroduction featureDescriptions={features.map(({ name }) => name)} />
      ),
    } as FeatureHighlight,
  ]
  const featureSlides = features.length ? firstSlide.concat(features) : []

  return (
    <Modal
      hideCloseButton
      isOpen={isOpen}
      maxWidth={960}
      maxHeight={720}
      onRequestClose={() => onClose()}
      shouldCloseOnOverlayClick={false}
    >
      <StyledModalHeader>
        <Button variant="transparent" compact onClick={() => onClose()}>
          Maybe later
        </Button>
      </StyledModalHeader>
      <StyledModalBody>
        <Carousel
          draggable={false}
          slideSize="100%"
          loop={false}
          withControls={false}
          disableIndicators
          slides={featureSlides.map((feature, idx) => {
            return {
              ...feature,
              component: embla => {
                const isLastFeature = idx === featureSlides.length - 1
                const handleNextFeature = () => {
                  const { id } = feature
                  if (id !== INTRO_SLIDE_ID && id && onNextFeature) onNextFeature(id)

                  if (isLastFeature) {
                    onClose(feature.id)
                  } else {
                    embla.scrollNext()
                  }
                }

                return (
                  <FeatureEducationSlideLayout
                    feature={feature}
                    onNextFeature={handleNextFeature}
                    nextFeature={featureSlides[idx + 1]}
                    isLastFeature={idx === featureSlides.length - 1}
                  />
                )
              },
            }
          })}
        />
      </StyledModalBody>
    </Modal>
  )
}

export default FeatureEducationModal
